import * as React from "react";
import {ReactElement} from "react";
import {useStore, useStoreValue} from "react-context-hook";
import Icon from "../Icon";
import {getConfiguration, getText} from "../../services/configuration.service";
import {useEffect} from "react";

const SelectDepartureCity = (): ReactElement => {
    const bookingEngineData = useStoreValue("bookingEngineData");
    const basePriceAvailability = ((bookingEngineData || {}).product || {}).basePriceAvailability;
    const availabilities = (bookingEngineData || {}).availabilities;
    const cities = (bookingEngineData || {}).cities;
    const [selectedDepartureCity, setSelectedDepartureCity] = useStore("selectedDepartureCity");
    const product = (bookingEngineData || {}).product;
    const isLocProduct = product && product.criteria.criteria && product.criteria.criteria.tvoyages
        && product.criteria.criteria.tvoyages[0] && product.criteria.criteria.tvoyages[0].code === "bien-etre";
    const isLocation = bookingEngineData?.product?.location;
    useEffect(() => {
        if (!selectedDepartureCity) {
            const queryParameters = getConfiguration().queryParameters;
            if (bookingEngineData && bookingEngineData.product) {
                // select from hash url
                let cityCode = basePriceAvailability.departureCity.code;
                if (queryParameters && queryParameters.city && availabilities[queryParameters.city]) {
                    cityCode = queryParameters.city;
                }
                // Select city of the base price availability of the product
                setSelectedDepartureCity({
                    code: cityCode,
                    value: availabilities[cityCode]
                });
            }
        }
    }, [bookingEngineData]);

    const selectCity = (cityCode: string) => {
        if (selectedDepartureCity.code !== cityCode) {
            setSelectedDepartureCity({code: cityCode, value: availabilities[cityCode]});
        }
    };

    return (
        <div className={`booking-item js-switch-active${(isLocProduct || isLocation) ? " hidden" : ""}`}>
            <div className="label">{getText("booking.select.departure.city.label")}</div>
            <div className={"elem-custom-select"}>
                <div className="custom-select-mask">
                    <div className="custom-select-input">
                        <div className="custom-select-input-txt">
                            <Icon icon={"l"} addClass={"location-icon"}/>
                            <div className="label-style">{(cities && selectedDepartureCity && cities[selectedDepartureCity.code]) || getText("booking.loading.label")}</div>
                        </div>
                        <div className="custom-select-input-button">{getText("booking.select.change")}</div>
                    </div>
                </div>
                <div className="custom-select-panel d-none">

                    <div className="title-block">
                        <div className="label-block">
                            <div className="label">{getText("booking.select.cities.available")}</div>
                            <div className="legend">{getText("booking.select.label")}</div>
                        </div>
                        <div className="icon-wrap btn-close-custom-select">
                            <Icon icon={"x"}/>
                        </div>
                    </div>
                    <div className="custom-select-panel-content">
                        {!cities &&
                        <div className="panel-content-item placeholder-style">{getText("booking.loading.label")}</div>
                        }
                        {cities && Object.keys(cities).map((cityCode: string) =>
                            <div
                                key={cityCode}
                                onClick={() => selectCity(cityCode)}
                                className={`panel-content-item ${cityCode === (selectedDepartureCity || {}).code ? "selected" : ""}`}
                            >
                                {cities[cityCode]}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectDepartureCity;
